import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import { useMatchResultUrl } from 'modules/payroll_bundle/hooks/useMatchPayrollUrls'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { usePolicies } from 'modules/payroll_bundle/store/collections/policies'
import type PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'

interface Props {
  policyPeriodSelected: PolicyPeriod
  setIsPopoverOpen: React.Dispatch<React.SetStateAction<boolean>>
  setOpeningNext: React.Dispatch<React.SetStateAction<boolean>>
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
}

export default function PolicyPeriodNavigator({
  policyPeriodSelected,
  setIsPopoverOpen,
  setOpeningNext,
  setOpenModal,
}: Props) {
  const policies = usePolicies()

  const { currentPeriod, currentPolicyPeriods, periodIndex, setPeriodIndex } = usePolicyPeriods()

  const { value: canChangePayrollStatus } = useAsyncCan('change_payroll_period_status.read')

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const policy = policyPeriodSelected && policies.get(policyPeriodSelected.attributes.policy_id)
  const policyId = policyPeriodSelected.id
  const periodId = currentPeriod?.id
  const isResultsTab = useMatchResultUrl(policyId, periodId)

  const navigateToCurrentPeriod = (periodIndex: number) => {
    const policyPeriodId = currentPolicyPeriods[periodIndex]?.id

    return navigate(
      navigation.payrollBundle.policy.period.results.fullPath({
        policyId,
        periodId: policyPeriodId,
      })
    )
  }

  const handlePrev = () => {
    if (periodIndex === 0) {
      setOpeningNext(false)
      setOpenModal(true)
      setIsPopoverOpen(false)

      return
    }

    setPeriodIndex(periodIndex - 1)
    isResultsTab && navigateToCurrentPeriod(periodIndex - 1)
  }

  const handleNext = () => {
    if (periodIndex === currentPolicyPeriods.length - 1) {
      setOpeningNext(true)
      setOpenModal(true)
      setIsPopoverOpen(false)
      return
    }

    setPeriodIndex(periodIndex + 1)
    isResultsTab && navigateToCurrentPeriod(periodIndex + 1)
  }

  if (!policy) return null

  const hasNext = canChangePayrollStatus || periodIndex < currentPolicyPeriods.length - 1
  return (
    <>
      <Box
        alignItems="center"
        flexDirection="row"
        gap="s8"
        paddingX="s24"
        justifyContent="spaceBetween"
        paddingBottom="s12"
      >
        <Button onClick={handlePrev} type="secondary">
          {i18n.t('payroll_bundle.payroll_policy.policy_period_selector.past_period')}
        </Button>

        {hasNext && (
          <Button onClick={handleNext} type="secondary">
            {i18n.t('payroll_bundle.payroll_policy.policy_period_selector.future_period')}
          </Button>
        )}
      </Box>
    </>
  )
}
